import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled, Box } from '@mui/material';
import { ReactComponent as SvgCheckmarkActiveIcon } from '../../../assets/icons/checkmark-active-icon.svg.js';

var Icon = styled(SvgCheckmarkActiveIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 10px;\n  height: 10px;\n  position: relative;\n  ", "\n"], ["\n  width: 10px;\n  height: 10px;\n  position: relative;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "fill: ".concat(theme.palette.highlighted, ";");
});
var Wrapper = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border: 1px dotted ", ";\n  border-radius: 2.5px;\n  position: relative;\n  flex: 0 0 18px;\n  width: 18px;\n  height: 18px;\n  overflow: hidden;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  border: 1px dotted ", ";\n  border-radius: 2.5px;\n  position: relative;\n  flex: 0 0 18px;\n  width: 18px;\n  height: 18px;\n  overflow: hidden;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral800;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral400;
});
var templateObject_1, templateObject_2;

export { Icon, Wrapper };
